'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var Reflux = require('reflux');
var DragDropMixin = require('react-dnd').DragDropMixin;

/* Stores */
var TeamStore = require('stores/team');
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');
var AssignedTeamItem = require('./assigned-team-item');

var AssignedTeamList = React.createClass({
  displayName: 'AssignedTeamList',

  mixins: [DragDropMixin, Reflux.connect(TeamStore, 'teams')],

  statics: {
    configureDragDrop: function configureDragDrop(registerType) {
      registerType('team_item', {
        dropTarget: {
          acceptDrop: function acceptDrop(component, item) {
            var onAssign = component.props.onAssign;

            if (onAssign) {
              onAssign(item);
            }
          }
        }
      });
    }
  },

  render: function render() {
    var component = this;
    var cx = React.addons.classSet;
    var dropState = component.getDropState('team_item');
    var classes = { "list-component assigned-teams-component": true };

    classes['drop-state-hover'] = dropState.isHovering;

    var teams = component.state.teams;
    var assignedTeamNodes = component.props.teams.filter(function (assignedTeam) {
      return teams.some(function (team) {
        return team.id === assignedTeam.teamId;
      });
    }).map(function (assignedTeam) {
      var team = teams.find(function (team) {
        return team.id === assignedTeam.teamId;
      });

      if (!team) {
        return null;
      }

      team.permission = assignedTeam.permission;

      return React.createElement(AssignedTeamItem, { key: team.id, team: team, onPermissionChange: component._onPermissionChange, onUnassign: component.props.onUnassign });
    }).filter(function (t) {
      return t;
    });

    /* Translations */
    var translate = LanguageStore.translate;

    if (!assignedTeamNodes.length) {
      var noContentTranslation = translate('datasource_details_assigned_teams_missing_title');
      assignedTeamNodes = React.createElement(
        'div',
        { className: 'item-component no-item-component' },
        noContentTranslation
      );
    }

    return React.createElement(
      TitledGroup,
      _extends({}, component.dropTargetFor('team_item'), {
        className: cx(classes),
        title: translate('datasource_details_assigned_teams_title') }),
      assignedTeamNodes
    );
  },

  _onPermissionChange: function _onPermissionChange(teamId, permission) {
    var props = this.props;
    if (props.onPermissionChange) {
      props.onPermissionChange(teamId, permission);
    }
  }
});

module.exports = AssignedTeamList;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/assigned-team-list.js
 **/